import { FormApi } from 'final-form';
import { OnChange } from '@occc/ui-forms';
import { Offer_Presentation_Type } from '@occc/graphql';

type AwardPresentationTypeWatcherProps = {
  form: FormApi<any>;
};

/**
 * Display Categories are only shown for awards using the Tile (Default) layout.
 *
 * When the Display Option (presentation type) changes to any non-tile layout,
 * the Display Categories field is hidden, so its value is cleared to avoid
 * persisting a stale category on a non-tile award. Re-selecting Tile starts
 * empty — the previously selected categories are not restored.
 */
export const AwardPresentationTypeWatcher = ({ form }: AwardPresentationTypeWatcherProps) => (
  <OnChange name='offer.presentationType'>
    {(presentationType: Offer_Presentation_Type) => {
      if (presentationType !== Offer_Presentation_Type.Default) {
        form.change('displayCategories', []);
      }
    }}
  </OnChange>
);
